import routesList from "@/routes/RouteComponent";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "@/routes/PrivateRoute";
import PublicRoute from "@/routes/PublicRoute";
function App() {
  const routeKeys = [];
  for (const route in routesList) {
    routeKeys.push(route);
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routeKeys.map((e) => {
            if (routesList[e].isPrivate) {
              return (
                <Route
                  key={`${routesList[e].path}`}
                  path={`${routesList[e].path}`}
                  element={
                    <PrivateRoute layout={routesList[e].layout}>
                      {routesList[e].component}
                    </PrivateRoute>
                  }
                />
              );
            } else {
              return (
                <Route
                  key={`${routesList[e].path}`}
                  path={`${routesList[e].path}`}
                  element={<PublicRoute>{routesList[e].component}</PublicRoute>}
                />
              );
            }
          })}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
